import React from "react";

export default function Star(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15.304" height="14.539">
			<path
				d="m7.652 11.685 4.729 2.854-1.255-5.379L15.3 5.54l-5.5-.467L7.652 0 5.5 5.073 0 5.54l4.178 3.619-1.255 5.38Z"
				fill="#d7a44d"
			/>
		</svg>
	);
}

export function StarLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="68" height="64">
			<path
				d="M34 51.436 55.012 64l-5.576-23.68L68 24.387l-24.446-2.054L34 0l-9.554 22.333L0 24.387 18.564 40.32 12.988 64Z"
				fill="#d7a44d"
			/>
		</svg>
	);
}
